import { DatePicker } from "@mui/x-date-pickers";
import { Controller, useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import { useError } from "../../../hooks";
import defaultValidationRules from "./defaultValidationRules";
import moment from "moment";

type DateControlProps = {
  required?: boolean;
  name: string;
  label?: string;
  enableAccessibleFieldDOMStructure?: boolean;
};

const DateControl = ({
  required,
  name,
  label,
  enableAccessibleFieldDOMStructure,
}: DateControlProps) => {
  const { control } = useFormContext();
  const intl = useIntl();
  const error = useError(name);
  const rules = defaultValidationRules({ required });
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <DatePicker
          label={intl.formatMessage({ id: label ?? name })}
          format="DD-MM-YYYY"
          value={field.value ? moment(field.value) : null}
          onChange={(date) => {
            field.onChange(date ? date.toISOString() : null);
          }}
          slotProps={{
            textField: {
              error: !!error,
              required: required,
              helperText: error?.message
                ? intl.formatMessage({ id: error.message as any })
                : null,
              variant: "standard",
              sx: { mb: 2 },
              fullWidth: true,
            },
          }}
        />
      )}
    />
  );
};

export default DateControl;
